import { FC } from 'react';
import CourseIcon1 from '../../static/assets/homepage/course-icon-1.svg';
import CourseIcon2 from '../../static/assets/homepage/course-icon-2.svg';
import CourseIcon3 from '../../static/assets/homepage/course-icon-3.svg';

import './HomeCourse.scss';

const HomeCourse: FC = () => (
	<section className="home-course home-section">
		<div className="internal-wrapper">
			<div className="home-section-header">
				<h2 className="home-course__title title-section title">
					Is this service right for you?
				</h2>
				<p className="home-course__subtitle subtitle-section">
					Use ready environment and concentrate on Frontend
				</p>
			</div>
			<div className="home-course__wrapper">
				<div className="home-course__items-wrapper">
					<div className="home-course__item">
						<div className="home-course__item-header">
							<img
								className="home-course__item-img"
								src={CourseIcon1}
								alt="Codeway.TODAY"
							/>
							<h3 className="home-course__item-title">
								Starting to learn a new framework?
							</h3>
						</div>
						<div className="home-course__item-text text-block">
							Learning React, Next.js, Angular, Vue, Svetle or anything else? This is
							perfect solution to narrow you efforts on Frontend without thinking about
							Backend setup and finding other meterials.
						</div>
					</div>
					<div className="home-course__item">
						<div className="home-course__item-header">
							<img
								className="home-course__item-img"
								src={CourseIcon2}
								alt="Codeway.TODAY"
							/>
							<h3 className="home-course__item-title">
								Learning new Backend technology?
							</h3>
						</div>
						<div className="home-course__item-text text-block">
							If you are looking to sharpen your skills in WebSockets or GraphQL, this
							is a perfect place to understand how to use it on the Frontend side. With
							our step-by-step product design you will easily create a real application
							on new technology.
						</div>
					</div>
					<div className="home-course__item">
						<div className="home-course__item-header">
							<img
								className="home-course__item-img"
								src={CourseIcon3}
								alt="Codeway.TODAY"
							/>
							<h3 className="home-course__item-title">
								Looking for candidate home assignments?
							</h3>
						</div>
						<div className="home-course__item-text text-block">
							Use our service to simulate a real application and review it after it is
							done. Contact us for more details and we will provide you with all needed
							materials.
						</div>
					</div>
				</div>
			</div>
		</div>
		<div className="home-course__overlay" />
	</section>
);

export default HomeCourse;
